/*
  MARAVEL Cookie Consent
  - Hides Shopify's native banner via API integration
  - Uses window.Shopify.customerPrivacy to gate Shopify's own tracking
  - Also stores in localStorage for instant subsequent-page reads
  - GDPR + ePrivacy compliant: equal prominence, no pre-ticked boxes
*/

(function () {
  var STORAGE_KEY = 'mv_cookie_consent';
  var EXPIRY_DAYS = 365;

  /* ── Shopify Customer Privacy API wrapper ───────────────────────────────── */
  function shopifySetConsent(analytics, marketing, cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics:   analytics,
        marketing:   marketing,
        preferences: true,
        // Shopify blokkeert pixels met "qualifies as data sale" zodra dit false is,
        // ook in de EU waar geen opt-out-recht bestaat; volg daarom de marketing-keuze.
        sale_of_data: marketing
      }, cb || function(){});
    } else if (cb) {
      cb();
    }
  }

  function shopifyGetConsent() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      return window.Shopify.customerPrivacy.getTrackingConsent(); // 'yes'|'no'|'no_interaction'
    }
    return null;
  }

  function shopifyShouldShow() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      return window.Shopify.customerPrivacy.shouldShowGDPR() !== false
          && shopifyGetConsent() === 'no_interaction';
    }
    return true; // no API → always show
  }

  /* ── Microsoft Clarity consent (ConsentV2) ──────────────────────────────
     Clarity's Shopify app registers as an "Always on" pixel — Shopify's
     native Customer Privacy API / Pixel Manager consent gating does not
     apply to it (confirmed: "Optimized" is disabled for it in Customer
     events). Clarity ignores Shopify's consent signal entirely and needs
     its own explicit call: https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-consent-api-v2 */
  function claritySetConsent(analytics) {
    if (window.clarity) {
      window.clarity('consentv2', {
        ad_Storage: analytics ? 'granted' : 'denied',
        analytics_Storage: analytics ? 'granted' : 'denied'
      });
    }
  }

  /* ── Local storage fallback ─────────────────────────────────────────────── */
  function getLocalConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      var age = (Date.now() - (obj.ts || 0)) / 86400000;
      if (age > EXPIRY_DAYS) { localStorage.removeItem(STORAGE_KEY); return null; }
      return obj;
    } catch (e) { return null; }
  }

  function saveLocalConsent(analytics, marketing) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        analytics: !!analytics, marketing: !!marketing, ts: Date.now()
      }));
    } catch (e) {}
  }

  /* ── Fire third-party analytics ─────────────────────────────────────────── */
  function fireAnalytics(analytics) {
    if (!analytics) return;
    var gaId = document.documentElement.dataset.gaId;
    if (gaId && !window._mvGaLoaded) {
      window._mvGaLoaded = true;
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaId;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', gaId, { anonymize_ip: true });
    }
  }

  /* ── DOM helpers ────────────────────────────────────────────────────────── */
  function $(id) { return document.getElementById(id); }

  function showBanner() {
    var b = $('mv-cookie-banner');
    if (!b) return;
    b.removeAttribute('hidden');
    b.style.display = 'block'; // belt-and-suspenders: override UA [hidden] → display:none
    /* Double rAF: first frame lets browser paint starting translateY(100%),
       second frame adds is-visible so CSS transition actually fires */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        b.classList.add('is-visible');
      });
    });
  }

  function hideBanner() {
    var b = $('mv-cookie-banner');
    if (!b) return;
    b.classList.remove('is-visible');
    setTimeout(function () {
      b.removeAttribute('style');
      b.setAttribute('hidden', '');
    }, 360);
  }

  function showPrefs() {
    var p = $('mv-cookie-prefs');
    var o = $('mv-cookie-overlay');
    if (!p) return;
    hideBanner();
    if (o) { o.removeAttribute('hidden'); requestAnimationFrame(function(){ o.classList.add('is-visible'); }); }
    p.removeAttribute('hidden');
    requestAnimationFrame(function () { p.classList.add('is-visible'); });
  }

  function hidePrefs() {
    var p = $('mv-cookie-prefs');
    var o = $('mv-cookie-overlay');
    if (p) {
      p.classList.remove('is-visible');
      setTimeout(function () { p.setAttribute('hidden', ''); }, 360);
    }
    if (o) {
      o.classList.remove('is-visible');
      setTimeout(function () { o.setAttribute('hidden', ''); }, 360);
    }
  }

  /* ── Consent actions ────────────────────────────────────────────────────── */
  function applyConsent(analytics, marketing) {
    saveLocalConsent(analytics, marketing);
    shopifySetConsent(analytics, marketing);
    claritySetConsent(analytics);
    hideBanner();
    hidePrefs();
    fireAnalytics(analytics);
  }

  function acceptAll()  { applyConsent(true,  true);  }
  function rejectAll()  { applyConsent(false, false); }

  function savePrefs() {
    var a = $('mv-toggle-analytics') && $('mv-toggle-analytics').checked;
    var m = $('mv-toggle-marketing') && $('mv-toggle-marketing').checked;
    applyConsent(a, m);
  }

  /* ── Event binding ──────────────────────────────────────────────────────── */
  function bindEvents() {
    document.querySelectorAll('[data-mv-cookie="accept-all"]') .forEach(function(b){ b.addEventListener('click', acceptAll);  });
    document.querySelectorAll('[data-mv-cookie="reject-all"]') .forEach(function(b){ b.addEventListener('click', rejectAll);  });
    document.querySelectorAll('[data-mv-cookie="open-prefs"]') .forEach(function(b){ b.addEventListener('click', showPrefs);  });
    document.querySelectorAll('[data-mv-cookie="save-prefs"]') .forEach(function(b){ b.addEventListener('click', savePrefs);  });
    document.querySelectorAll('[data-mv-cookie="close-prefs"]').forEach(function(b){ b.addEventListener('click', hidePrefs);  });

    var overlay = $('mv-cookie-overlay');
    if (overlay) overlay.addEventListener('click', hidePrefs);

    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') hidePrefs(); });

    /* Footer "Gestionar cookies" link */
    document.addEventListener('click', function(e) {
      if (e.target && e.target.closest('[data-mv-cookie-reopen]')) {
        e.preventDefault();
        showBanner();
      }
    });
  }

  /* ── Init ───────────────────────────────────────────────────────────────── */
  function init() {
    bindEvents();

    /* localStorage is the source of truth — works in incognito + all regions */
    var lc = getLocalConsent();
    if (lc) {
      fireAnalytics(lc.analytics);
      /* Sync recorded consent into Shopify's API (gates Optimized-tier pixels
         like Google & YouTube / Klaviyo) and into Clarity directly (its pixel
         is registered as Always-on and ignores Shopify's signal entirely) */
      shopifySetConsent(lc.analytics, lc.marketing);
      claritySetConsent(lc.analytics);
      return;
    }

    /* No stored consent yet — explicitly deny via both APIs immediately, so
       neither Shopify's Optimized-tier pixels nor Clarity (Always-on, needs
       its own signal) fire before the visitor makes a real choice. Local
       storage stays untouched (no 'ts' saved) so the banner still shows and
       a real choice still wins. */
    shopifySetConsent(false, false);
    claritySetConsent(false);

    /* Show banner after a brief delay so page renders first */
    setTimeout(showBanner, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MaravelCookie = { open: showBanner, openPrefs: showPrefs };
})();
